export const openInSameTab = url => window.location.assign(url);

export const openInNewTab = url => window.open(url, '_blank', 'noopener,noreferrer');

export const openOffer = (url, isSmallViewport) => (isSmallViewport ? openInSameTab(url) : openInNewTab(url));
